'use strict'

/**
 *
 * @name: singleSeries
 *
 */

import DirectiveTemplate from './nn-single-seasons.directive.html'
import './nn-single-seasons.directive.scss'

function SingleSeasonsDirective(
  $timeout,
  apiPostService,
  transObject,
  $state,
  seasonsAnalytics,
  $rootScope
) {

  'ngInject'

  return {
    replace: true,
    restrict: 'A',
    transclude: true,
    scope: {
      content: '&',
      loaded: '='
    },
    template: DirectiveTemplate,
    link: function(scope, element) {

      scope.item = scope.content()
      scope.seasonsAnalytics = seasonsAnalytics
      scope.stateName = $state.current.name
      scope.settings = {
        totalPages: null,
        page: 1
      }
      scope.swiperOptions = {
        spaceBetween: $rootScope.$bp === 'ltMobileXS' ? 10 : 30 ,
        on: {
          reachEnd: () => {
            scope.loadMore()
          }
        }
      }

      scope.onAnalyticsClick = post => {
        $rootScope.analytics.videoAM('single seasons', scope.item.title, post)
      }

      function terminate() {
        scope.$destroy()
        element.find('*').remove()
        element.remove()
      }

      void 0
      if (!scope.item.jsonData.sources || !scope.item.jsonData.sources[0] || !scope.item.jsonData.sources[0].seasonId) {
        void 0
        return terminate()
      }

      scope.item.title = scope.item.title || 'SEASONS'
      void 0

      apiPostService
        .GET_POST({
          order: 'publishDate desc',
          page: 1,
          limit: 8,
          isPublished: 'allOfThem',
          seasonId: scope.item.jsonData.sources[0].seasonId,
          includeComingSoon: true
        })
        .then(function(result) {

          if (result.data.items.length < 2) {
            terminate()
          }

          scope.settings.totalPages = result.data.meta.totalPages

          result.data.items.forEach(function(item, index) {

            if (index === 0 && !scope.item.seasons[0]) {
              scope.item.seasons[0] = item.series
            }
            transObject.translate(item)
            transObject.getDuration(item)
            transObject.setBookmark(item)
            transObject.isPublished(item)
            transObject.trueSlug(item)
          })

          transObject.translate(scope.item.seasons[0])
          scope.item.seasons[0].posts = result.data.items
          scope.loaded = true
        })

      scope.loadMore = function() {

        if (scope.item.seasons[0].posts.length && !scope.disableIS && scope.settings.page < scope.settings.totalPages) {

          scope.settings.page++
          scope.disableIS = true

          apiPostService
            .GET_POST({
              order: 'publishDate desc',
              page: scope.settings.page,
              limit: 8,
              isPublished: 'allOfThem',
              seasonId: scope.item.seasons[0].id,
              includeComingSoon: true
            })
            .then(function(result) {

              result.data.items.forEach(function(item) {

                transObject.translate(item)
                transObject.getDuration(item)
                transObject.setBookmark(item)
                transObject.isPublished(item)
                transObject.trueSlug(item)
                scope.item.seasons[0].posts.push(item)
              })

              scope.disableIS = false

              scope.baseSwiper.setUpdate()
            })
        }
      }
    }
  }
}

export default SingleSeasonsDirective



// WEBPACK FOOTER //
// ./app/components/nn-modules/seasons/nn-single-seasons/nn-single-seasons.directive.js